// extracted by mini-css-extract-plugin
module.exports = {"header":"XxxHeader_header__1_1KF","headerTitle":"XxxHeader_headerTitle__1_81R","logo":"XxxHeader_logo__3G4XE","searchBoxContainer":"XxxHeader_searchBoxContainer__2v2F3"};